import { useEffect } from "react";
import { API } from "@/lib/api";
import "./portal.css";

export const CAPI = `${API}/client`;

// Session portée uniquement par le cookie httpOnly cp_session -> credentials:"include".
export async function capi(path, { method = "GET", body } = {}) {
  return fetch(`${CAPI}${path}`, {
    method,
    headers: body ? { "Content-Type": "application/json" } : {},
    credentials: "include",
    body: body ? JSON.stringify(body) : undefined,
  });
}

export function apiError(detail) {
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e?.msg || "").join(" ").trim();
  return "Une erreur est survenue. Réessayez.";
}

// Dates en français : "2026-01-01" -> "1 janv. 2026"
export function frDate(s) {
  if (!s) return "—";
  const d = new Date(s);
  if (isNaN(d.getTime())) return s;
  return new Intl.DateTimeFormat("fr-FR", { day: "numeric", month: "short", year: "numeric" }).format(d);
}

// noindex client-side (comme CapturesAdmin)
export function useNoindex() {
  useEffect(() => {
    const m = document.createElement("meta");
    m.name = "robots";
    m.content = "noindex, nofollow";
    document.head.appendChild(m);
    return () => { document.head.removeChild(m); };
  }, []);
}
